export const CONTACT_OPTIONS_PHONE_NUMBER_LABEL = 'Anruf';
export const CONTACT_OPTIONS_PHONE_NUMBER_KEY = 'phoneNumber';
export const CONTACT_OPTIONS_WHATSAPP_LABEL = 'WhatsApp';
export const CONTACT_OPTIONS_WHATSAPP_KEY = 'whatsapp';
export const CONTACT_OPTIONS_SIGNAL_LABEL = 'Signal';
export const CONTACT_OPTIONS_SIGNAL_KEY = 'signal';
export const CONTACT_OPTIONS_TELEGRAM_LABEL = 'Telegram';
export const CONTACT_OPTIONS_TELEGRAM_KEY = 'telegram';
export const CONTACT_OPTIONS_THREEMA_LABEL = 'Threema';
export const CONTACT_OPTIONS_THREEMA_KEY = 'threema';

export const contactOptions = [
    {
        label: CONTACT_OPTIONS_PHONE_NUMBER_LABEL,
        key: CONTACT_OPTIONS_PHONE_NUMBER_KEY,
    },
    {
        label: CONTACT_OPTIONS_WHATSAPP_LABEL,
        key: CONTACT_OPTIONS_WHATSAPP_KEY,
    },

    {
        label: CONTACT_OPTIONS_SIGNAL_LABEL,
        key: CONTACT_OPTIONS_SIGNAL_KEY,
    },
    {
        label: CONTACT_OPTIONS_TELEGRAM_LABEL,
        key: CONTACT_OPTIONS_TELEGRAM_KEY,
    },
    {
        label: CONTACT_OPTIONS_THREEMA_LABEL,
        key: CONTACT_OPTIONS_THREEMA_KEY,
    },
];
